import './css/styles.scss';

let isScrolling: number;

function throttle(func: () => void, limit: number) {
	let inThrottle: boolean;
	return function () {
		if (!inThrottle) {
			func();
			inThrottle = true;
			setTimeout(() => (inThrottle = false), limit);
		}
	};
}
function initStickyHeader() {
	const header = document.querySelector('header.wp-block-template-part') as HTMLElement;
	if (!header) return;

	let headerOffset = header.offsetHeight;

	const adminBar = document.querySelector('#wpadminbar') as HTMLElement;
	if (adminBar) {
		headerOffset += adminBar.offsetHeight;
	}
	//console.log('initStickyHeader');
	//console.log(headerOffset);

	let currentScroll = window.pageYOffset || document.documentElement.scrollTop;

	const windowScroll = window.scrollY || window.pageYOffset;

	const threshold = 4; // Adjust this value to your needs

	if (currentScroll >= threshold) {
		header.classList.add('fixed-header');
	} else {
		header.classList.remove('fixed-header');
	}
}


const throttledInitStickyHeader = throttle(initStickyHeader, 25);

window.addEventListener('load', function () {
	throttledInitStickyHeader();
	window.addEventListener('resize', throttledInitStickyHeader);
	window.addEventListener('scroll', function () {
		// Clear our timeout throughout the scroll
		window.clearTimeout(isScrolling);

		// Set a timeout to run after scrolling ends
		isScrolling = setTimeout(function () {
			// Run the callback
			initStickyHeader();
		}, 66);

		// Call the throttled function for while scrolling
		throttledInitStickyHeader();
	});
});

// when dom is ready



function fixedPadding() {
	const header = document.querySelector('header');
	if (header) {
		/*const headerHeight = (header as HTMLElement).offsetHeight;
		const windowWidth = window.innerWidth;
		const heroSection = document.querySelector('section.hero-bildspel-section');
		const heroSectionSubPage = document.querySelector('section.is-style-subpage-hero');
		const kaksmulor = document.querySelector('.is-style-kaksmulor');
		if (heroSection) {
			(heroSection as HTMLElement).style.marginTop = `${headerHeight}px`;
		}
		if (heroSectionSubPage && windowWidth > 1280) {
			//(heroSectionSubPage as HTMLElement).style.marginTop = `${headerHeight}px`;
			(heroSectionSubPage as HTMLElement).style.marginTop = `16px`;
		}
		if (kaksmulor) {
			(kaksmulor as HTMLElement).style.marginTop = `${headerHeight}px`;
		}
		if (heroSectionSubPage && windowWidth < 1280) {
			const headerHeightNew = 16;
			(heroSectionSubPage as HTMLElement).style.marginTop = `${headerHeightNew}px`;
		}
		if (heroSectionSubPage && windowWidth < 600) {
			const headerHeightNew = 8;
			(heroSectionSubPage as HTMLElement).style.marginTop = `${headerHeightNew}px`;

		} */

	}
}

// Sökpanel: förstoringsglaset bredvid varukorgen öppnar/stänger [aws_search_form]
function initSearchToggle() {
	const toggle = document.querySelector('[data-search-toggle]') as HTMLButtonElement;
	const panel = document.querySelector('[data-search-panel]') as HTMLElement;
	if (!toggle || !panel) return;

	const setOpen = (open: boolean) => {
		panel.hidden = !open;
		toggle.setAttribute('aria-expanded', String(open));
		if (open) {
			const input = panel.querySelector('.aws-search-field, input[name="s"]') as HTMLInputElement;
			input?.focus();
		}
	};

	toggle.addEventListener('click', () => setOpen(panel.hidden));

	// Stäng med Escape eller klick utanför
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && !panel.hidden) {
			setOpen(false);
			toggle.focus();
		}
	});
	document.addEventListener('click', (e) => {
		const target = e.target as Node;
		if (panel.hidden || panel.contains(target) || toggle.contains(target)) return;
		// AWS live-resultat renderas utanför panelen – stäng inte vid klick där
		if ((target as HTMLElement).closest?.('.aws-search-result')) return;
		setOpen(false);
	});
}

// on dom ready
// Make sure to call the function -.-'
document.addEventListener('DOMContentLoaded', () => {
	fixedPadding();
	initSearchToggle();
});
